import React from 'react';

import styled from '@emotion/styled';

import { IconProps } from '../../IconsProps';

const StyledHelpSVG = styled.svg<IconProps>`
  & .cls-1,
  .cls-2,
  .cls-4 {
    fill: none;
  }

  & .cls-2,
  .cls-3,
  .cls-4 {
    stroke: var(--chatbot-color-primary, #404040);
  }

  & .cls-2 {
    stroke-linejoin: round;
  }

  & .cls-3 {
    fill: #fff;
  }

  & .cls-5 {
    stroke: none;
  }
`;

const HelpIcon: React.FC<IconProps> = ({ active }) => {
  const activeclass = active ? 'active' : undefined;
  return (
    <StyledHelpSVG
      id='Help-Icon-SVG'
      xmlns='http://www.w3.org/2000/svg'
      width='32'
      height='32'
      viewBox='0 0 32 32'
      className={activeclass}
    >
      <g id='Help' transform='translate(-2081 -2766)'>
        <rect id='Margin' className='cls-1' width='32' height='32' transform='translate(2081 2766)' />
        <g id='Group_17484' data-name='Group 17484' transform='translate(0.376 -3.742)'>
          <path
            id='Path_15951'
            data-name='Path 15951'
            className='cls-2'
            d='M1654.45,1024.319a2.379,2.379,0,0,1,1.032-1.252,2.361,2.361,0,0,1,3.557,2.039c0,1.574-2.361,2.361-2.361,2.361v1.438'
            transform='translate(439.88 1758.184)'
          />
          <g id='Ellipse_247778' data-name='Ellipse 247778' className='cls-3' transform='translate(2095.624 2788.558)'>
            <circle className='cls-5' cx='1' cy='1' r='1' />
            <circle className='cls-1' cx='1' cy='1' r='0.5' />
          </g>
          <g id='Ellipse_247779' data-name='Ellipse 247779' className='cls-4' transform='translate(2088.624 2777.742)'>
            <circle className='cls-5' cx='8' cy='8' r='8' />
            <circle className='cls-1' cx='8' cy='8' r='7.5' />
          </g>
        </g>
      </g>
    </StyledHelpSVG>
  );
};

export default HelpIcon;
